import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header/Header";
import LandingPage from "./pages/LandingPage/landing-page";
import LoginPage from "./pages/LoginPage/login-page";
import RegisterPage from "./pages/RegisterPage/register-page";
import Profile from "./pages/Profile/profile";
import ExporterTestPage from "./pages/ExporterTest/exporter-test";
import CubicajePage from "./pages/Cubicaje/cubicaje";
import Footer from "./components/Footer/Footer";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { FormProvider } from "./context/FormContext";
import InformationPage from "./pages/Information/information-page";
import RestorePasswordPage from "./pages/RPasswordPage/restore-password";
import "./styles/styles.css";
import TerminosServicioPage from "./pages/TerminosServicio/terminosservicio";
import PriceComparatorPage from "./pages/PriceComparator/price-comparator";
import PoliticasPrivacidadPage from "./pages/PoliticasPrivacidad/politicasprivacidad";
import NoticiasPage from "./pages/Noticias/noticias";
import NoticiaPage from "./pages/Noticias/noticia";
import AcercaInterconectarPage from "./pages/AcercaInterconectar/acercaInterconectar";
import ServiciosPage from "./pages/Servicios/servicios";
import FinalReport from "./pages/Information/FinalReport/finalReport";
import PreferencesPage from "./pages/Preferences/preferences-page";
import PriceCalculatorPage from "./pages/PriceCalculator/price-calculator";
import { VideoProvider } from "./context/VideoContext";
import { ComparatorVideoProvider } from "./context/ComparatorVideoContext";
import { QueryClient, QueryClientProvider } from "react-query";
import ActivateAccountPage from "./pages/ActivateAccount/activate-account";
import RecoverPasswordPage from "./pages/RecoverPassword/recover-password";
import { SuscripcionesPage } from "./pages/Suscripciones/SuscripcionesPage";

import SearchPage from "./pages/SearchPage/SearchPage";
import { setAuthDispatch } from "./api/mutator/customInstance";

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <FormProvider>
            <VideoProvider>
              <ComparatorVideoProvider>
                <AppContent />
              </ComparatorVideoProvider>
            </VideoProvider>
          </FormProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
};

const AppContent: React.FC = () => {
  
  const { state, dispatch } = useAuth();
  const { pathname } = useLocation();

  const navigate = useNavigate();
  let variation: "error" | "register_ok" | "email_register" | "email_password" =
    "error";

    useEffect(() => {
      setAuthDispatch(dispatch);
  }, [dispatch]);  

  useEffect(() => {
    
    if ( !state.isAuthenticated  ){
      dispatch({ type: "LOGOUT" });
    }
  
  }, [state.isAuthenticated, pathname, navigate]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const getPageComponent = (page: React.JSX.Element) => {
    return state.isAuthenticated ? page : <LoginPage />;
  };

  // Páginas en las que NO se debe mostrar el Footer
  const hideFooterRoutes = [
    "/login",
    "/activate-account",
    "/recover-password",
    "/register",
    "/reset-password",
  ];

  // Verifica si el pathname comienza con alguna de las rutas especificadas
  const shouldHideFooter = hideFooterRoutes.some((route) =>
    pathname.startsWith(route)
  );

  return (
    <div className="row_app">
      <Header />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<LandingPage />} />        
        <Route path="/suscripciones" element={<SuscripcionesPage />} />
        <Route
          path="/register"
          element={state.isAuthenticated ? <Navigate to="/" replace /> : <RegisterPage />}
        />
        <Route
          path="/activate-account/:token"
          element={<ActivateAccountPage />}
        />
        <Route
          path="/recover-password"
          element={<RecoverPasswordPage />}
        />
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/exportertest"
          element={getPageComponent(<ExporterTestPage />)}
        />
        <Route
          path="/information"
          element={<InformationPage variation={variation} />}
        />
        <Route
          path="/informe-final-test-exportador"
          element={<FinalReport />}
        />
        <Route path="/reset-password/:token" element={<RestorePasswordPage />} />
        <Route
          path="/login"
          element={state.isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
        />
        <Route path="/register" element={getPageComponent(<RegisterPage />)} />
        <Route path="/cubicaje" element={getPageComponent(<CubicajePage />)} />
        <Route path="/terminosservicio" element={<TerminosServicioPage />} />
        <Route
          path="/pricecomparator"
          element={getPageComponent(<PriceComparatorPage />)}
        />
        <Route
          path="/politicasprivacidad"
          element={<PoliticasPrivacidadPage />}
        />
         <Route path="/noticias" element={<NoticiasPage />} />
        <Route path="/noticias/:keyword" element={<NoticiasPage />} />
        <Route path="/noticia/:id" element={<NoticiaPage />} />
        <Route path="/search" element={<SearchPage />} /> 
        <Route
          path="/acerca-interconectar"
          element={<AcercaInterconectarPage />}
        />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/preferencias" element={<PreferencesPage />} />
        <Route path="/calcularprecios" element={<PriceCalculatorPage />} />
      </Routes>
      
      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default App;
